import {connect} from 'react-redux'
import * as logActions from "../actions/logActions";
import MainErrorHandler from "../../Components/MainErrorHandler/MainErrorHandler";

const mapStateToProps = (store) => {
    return {};
};

const mapDispatchToProps = {
    logError: logActions.logErrorAction
};

const MainErrorHandlerContainer = connect(mapStateToProps, mapDispatchToProps)(MainErrorHandler);

export default MainErrorHandlerContainer;